import checks from './checks';
import accounts from './accounts';
import auth from './auth';
import replies from './replies';

export default {
    namespaced: true,
    modules: {
        checks,
        accounts,
        auth,
        replies,
    }
}